import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, Component } from 'react';
import styled from 'styled-components';
import { NAV_ITEM_INNER_SPACING_X } from 'HubStyleTokens/sizes';
import { isRenderable } from '../utils/propTypes/componentProp';
const NavItemLabel = styled.span.withConfig({
  displayName: "UINavItemLabel__NavItemLabel",
  componentId: "w7xof2-0"
})(["align-items:center;display:flex;flex-grow:1;width:100%;"]);
const Count = styled.span.withConfig({
  displayName: "UINavItemLabel__Count",
  componentId: "w7xof2-1"
})(["margin-left:auto;padding-left:", ";"], NAV_ITEM_INNER_SPACING_X);

class UINavItemLabel extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      className,
      count
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "count"]);

    return /*#__PURE__*/_jsxs(NavItemLabel, Object.assign({}, rest, {
      className: className,
      children: [/*#__PURE__*/_jsx(Fragment, {
        children: children
      }), isRenderable(count) && /*#__PURE__*/_jsx(Count, {
        children: count
      })]
    }));
  }

}

UINavItemLabel.displayName = 'UINavItemLabel';
UINavItemLabel.propTypes = {
  children: PropTypes.node,
  count: PropTypes.node
};
export default UINavItemLabel;